import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Divider,
  Header,
  Modal,
  Grid,
  Icon,
  Input,
  Popup,
  Segment
} from 'semantic-ui-react';
import {
  Analytics,
  AvailabilityCalendar,
  BigCalendarInTimeZone,
  GlobalNotifications,
  Intent
} from '../../Modules';
import AvailabilityDetails from '../../Modules/AvailabilityChecker/AvailabilityDetails';
import { withRouter } from 'found';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import globalStyles from '../../globals.scss';
import ClipboardButton from 'react-clipboard.js';
import BigCalendarUtils from '../../../lib/utils/bigCalendar';
import EventsHelper from '../../../lib/utils/events';

const EventCalendar = class EventCalendar extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    location: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    mobile: PropTypes.bool,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.closeSearchHandler = this.closeSearchHandler.bind(this);
    this.selectEvent = this.selectEvent.bind(this);
    this.openAvailabilityChecker = this.openAvailabilityChecker.bind(this);
    this.closeAvailabilityChecker = this.closeAvailabilityChecker.bind(this);
    this.openAvailabilityDetails = this.openAvailabilityDetails.bind(this);
    this.closeAvailabilityDetails = this.closeAvailabilityDetails.bind(this);
    this.updateSelectedDay = this.updateSelectedDay.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onSuccessfulCopy = this.onSuccessfulCopy.bind(this);
    this.getCalUrl = this.getCalUrl.bind(this);
    this.closeSyncInstructions = this.closeSyncInstructions.bind(this);
    this.openSyncInstructions = this.openSyncInstructions.bind(this);
    this.updateCalendarView = this.updateCalendarView.bind(this);
    this.onNavigate = this.onNavigate.bind(this);
    this.onViewChange = this.onViewChange.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.getSelectedDay = this.getSelectedDay.bind(this);

    this.state = {
      showSearch: false,
      showAvailabilityChecker: false,
      showAvailabilityDetails: false,
      eventsOnDay: [],
      syncInstructionsOpen: false,
      eventsByDate: {},
      flattenedEventSegments: []
    };
  }

  componentWillMount() {
    this.props.relay.refetch((fragmentVariables) => Object.assign({}, fragmentVariables, {
      afterTime: moment(this.getSelectedDay())
        .startOf('month')
        .subtract(1, 'month')
        .toISOString(),
      beforeTime: moment(this.getSelectedDay())
        .startOf('month')
        .add(1, 'month')
        .toISOString(),
      returnEmptyConnection: false
    }));
    const userEvents = this.props.viewer
      ? this.props.viewer.EventCalendar_user_events.edges
      : [];
    this.setState({
      flattenedEventSegments: BigCalendarUtils.getFlattenedEventSegments(
        userEvents
      )
    });
  }

  componentWillReceiveProps(nextProps) {
    const userEvents = nextProps.viewer
      ? nextProps.viewer.EventCalendar_user_events.edges
      : [];
    this.setState({
      flattenedEventSegments: BigCalendarUtils.getFlattenedEventSegments(
        userEvents
      )
    });
  }

  componentDidMount() {
    Analytics.trackEvent('viewed-calendar');
  }

  onFocus(e) {
    e.target.select();
  }

  onSuccessfulCopy() {
    GlobalNotifications.show({
      message: 'Successfully copied calendar URL',
      intent: Intent.SUCCESS
    });
  }

  getCalUrl(status) {
    return `${process.env.BASE_URL}/calendars/${this.props.viewer
      .calendar_token}/${status}.ics`;
  }

  getSelectedDay() {
    const { selectedDay } = this.props.location.query;
    return selectedDay ? new Date(selectedDay) : new Date();
  }

  setQuery(key, value) {
    const { pathname, query } = this.props.location;
    query[key] = value;
    this.props.router.replace({ pathname, query });
  }

  openAvailabilityChecker() {
    this.setState({ showAvailabilityChecker: true });
  }

  closeAvailabilityChecker() {
    this.setState({ showAvailabilityChecker: false });
  }

  openAvailabilityDetails(props) {
    this.setState({
      showAvailabilityChecker: this.props.mobile,
      showAvailabilityDetails: true,
      ...props
    });
  }

  closeAvailabilityDetails() {
    this.setState({ showAvailabilityDetails: false });
  }

  updateSelectedDay(selectedDay) {
    this.setQuery('selectedDay', selectedDay.toISOString());
    this.setState({
      eventsOnDay: EventsHelper.groupEventsByDate(
        this.props.viewer.EventCalendar_user_events.edges,
        selectedDay,
        this.props.viewer.s_time_zone
      )[selectedDay.getDate()]
    });
    // If within a month of range, make a new request
    this.props.relay.refetch((fragmentVariables) => Object.assign({}, fragmentVariables, {
      afterTime: moment(selectedDay)
        .startOf('month')
        .subtract(1, 'month')
        .toISOString(),
      beforeTime: moment(selectedDay)
        .startOf('month')
        .add(1, 'month')
        .toISOString(),
      returnEmptyConnection: false
    }));
  }

  updateCalendarView(calendarView) {
    this.setQuery('calendarView', calendarView);
  }

  toggleSearch() {
    this.setState({ showSearch: !this.state.showSearch });
  }

  closeSearchHandler() {
    this.setState({ showSearch: false });
  }

  selectEvent(event) {
    this.props.router.push(`/events/${event.id}`);
  }

  closeSyncInstructions() {
    this.setState({ syncInstructionsOpen: false });
  }

  openSyncInstructions() {
    this.setState({ syncInstructionsOpen: true });
  }

  onNavigate(date) {
    this.updateSelectedDay(date);
  }

  onViewChange(view) {
    this.updateCalendarView(view);
  }

  render() {
    const Event = ({ event }) =>
      <Popup
        trigger={
          <span>
            <strong>
              {event.title}
            </strong>
          </span>
        }
        on='hover'
        inverted
        content={event.title}
      />;

    const events = this.state.flattenedEventSegments;

    const copyButton = status =>
      <ClipboardButton
        option-text={this.getCalUrl.bind(null, status)}
        onSuccess={this.onSuccessfulCopy}
        className='ui right icon button button'
      >
        <span>
          Copy &nbsp;<Icon name='copy outline' />
        </span>
      </ClipboardButton>;

    const CalendarHeader = ({ view, label }) =>
      <Grid style={{ marginTop: '1em', marginBottom: '1em' }}>
        <Grid.Row columns='equal'>
          <Grid.Column>
            <Button.Group basic size='small'>
              <Button
                content='Day'
                active={view === 'day'}
                onClick={this.updateCalendarView.bind(null, 'day')}
              />
              <Button
                content='Week'
                active={view === 'week'}
                onClick={this.updateCalendarView.bind(null, 'week')}
              />
              <Button
                content='Month'
                active={view === 'month'}
                onClick={this.updateCalendarView.bind(null, 'month')}
              />
            </Button.Group>
          </Grid.Column>
          <Grid.Column textAlign='center'>
            <h3>{label}</h3>
          </Grid.Column>
          <Grid.Column textAlign='right'>
            <Button.Group basic size='small' style={{ marginLeft: '2em' }}>
              <Button
                icon='chevron left'
                onClick={this.updateSelectedDay.bind(
                  null,
                  moment(this.getSelectedDay()).subtract(1, view).toDate()
                )}
              />
              <Button
                content='Today'
                onClick={this.updateSelectedDay.bind(null, new Date())}
              />
              <Button
                icon='chevron right'
                onClick={this.updateSelectedDay.bind(
                  null,
                  moment(this.getSelectedDay()).add(1, view).toDate()
                )}
              />
            </Button.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>;

    return (
      <div style={{ width: '100%' }}>
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Segment>
                <div className={globalStyles.desktop}>
                  <BigCalendarInTimeZone
                    events={events}
                    step={60}
                    timeslots={2}
                    defaultView='month'
                    showMultiDayTimes
                    view={this.props.location.query.calendarView || 'month'}
                    defaultDate={new Date()}
                    timeZone={this.props.viewer.s_time_zone}
                    date={this.getSelectedDay()}
                    eventPropGetter={BigCalendarUtils.eventPropGetter}
                    style={{ minHeight: '600px' }}
                    components={{
                      event: Event,
                      toolbar: CalendarHeader
                    }}
                    formats={{
                      timeGutterFormat: 'h A',
                      dayFormat: 'ddd M/D',
                      dayHeaderFormat: 'dddd MMM D, Y',
                      dayRangeHeaderFormat: ({ start, end }, culture, local) =>
                        `${local.format(start, 'MMMM D', culture)}${moment(
                          start
                        ).isSame(end, 'year')
                          ? ''
                          : local.format(start, ', Y', culture)} -
                        ${local.format(
                          end,
                          moment(start).isSame(end, 'month') ? 'D' : 'MMMM D',
                          culture
                        )},
                        ${local.format(end, 'Y', culture)}`
                    }}
                    onSelectEvent={this.selectEvent}
                    onNavigate={this.onNavigate}
                    onView={this.onViewChange}
                    views={['month', 'week', 'day']}
                  />
                </div>
                <div className={globalStyles.mobile}>
                  <AvailabilityCalendar
                    initialMonth={this.getSelectedDay()}
                    selectedDay={this.getSelectedDay()}
                    onDayClick={() => {}}
                    updateSelectedDay={this.updateSelectedDay}
                    viewer={this.props.viewer}
                    close={this.closeAvailabilityChecker}
                    openAvailabilityDetails={this.openAvailabilityDetails}
                    showDetails
                    mobile
                  />
                  <AvailabilityDetails
                    isOpen={this.state.showAvailabilityDetails}
                    close={this.closeAvailabilityDetails}
                    eventsOnDay={this.state.eventsOnDay}
                    updateSelectedDay={this.updateSelectedDay}
                    selectedDay={this.getSelectedDay()}
                    viewer={this.props.viewer}
                  />
                </div>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Modal
                trigger={
                  <a onClick={this.openSyncInstructions}>
                    <Button
                      basic
                      icon='refresh'
                      content='Sync Calendar to Other Devices'
                    />
                  </a>
                }
                open={this.state.syncInstructionsOpen}
                onClose={this.closeSyncInstructions}
              >
                <Header content='Syncing to Your Devices' />
                <Modal.Content>
                  <Grid columns='equal' stackable>
                    <Grid.Row>
                      <Grid.Column>
                        <h4>
                          You can sync Cloverbook events with all your devices.
                          Here are some tutorials to help you get setup:
                        </h4>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <h3>Apple</h3>
                        <p>
                          <a
                            href='https://support.apple.com/en-us/HT202361'
                            target='blank'
                          >
                            iCloud (All Apple Devices)
                          </a>
                        </p>
                        <p>
                          <a
                            href='https://support.apple.com/kb/PH11523?viewlocale=en_US&locale=en_US'
                            target='blank'
                          >
                            Mac
                          </a>
                        </p>
                        <p>
                          <a
                            href='https://discussions.apple.com/thread/7759000?language=en'
                            target='blank'
                          >
                            iPhone
                          </a>
                        </p>
                        <h3>Android</h3>
                        <p>
                          <a
                            href='https://support.google.com/calendar/answer/37100?hl=en&co=GENIE.Platform%3DAndroid&oco=1'
                            target='blank'
                          >
                            Android
                          </a>
                        </p>
                      </Grid.Column>
                      <Grid.Column>
                        <h3>Other</h3>
                        <p>
                          <a
                            href='https://support.office.com/en-us/article/Import-or-subscribe-to-a-calendar-in-Outlook-com-or-Outlook-on-the-web-CFF1429C-5AF6-41EC-A5B4-74F2C278E98C'
                            target='blank'
                          >
                            Outlook
                          </a>
                        </p>
                        <p>
                          <a
                            href='https://support.google.com/calendar/answer/37100?hl=en&co=GENIE.Platform%3DiOS&oco=1'
                            target='blank'
                          >
                            Google Calendar
                          </a>
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                    <Divider section />
                    <Grid.Row>
                      <Grid.Column>
                        <h4>
                          Copy and paste the URLs below into your favorite
                          calendar app to get the latest updates on any device.
                        </h4>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <p>
                          <strong>Booked Events</strong>
                        </p>
                        <Input
                          onFocus={this.onFocus}
                          value={this.getCalUrl('booked')}
                          action={copyButton('booked')}
                          onChange={() => {}}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <p>
                          <strong>Not Booked Events</strong>
                        </p>
                        <Input
                          onFocus={this.onFocus}
                          value={this.getCalUrl('not_booked')}
                          action={copyButton('not_booked')}
                          onChange={() => {}}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <p>
                          *This is the private address for this calendar.
                          Don&apos;t share this address with others unless you
                          want them to see all the events on this calendar.
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Modal.Content>
                <Modal.Actions>
                  <Button onClick={this.closeSyncInstructions}>Close</Button>
                </Modal.Actions>
              </Modal>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
};

export default withRouter(EventCalendar);



// WEBPACK FOOTER //
// ./webpack/components/Event/List/EventCalendar.js